import React from 'react';
import { Icon } from './Icon.js';
export const IconFollowObjDownRightFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m5.25.75c-.414,0-.75.336-.75.75v1.939L1.548.487C1.255.194.78.194.487.487S.194,1.255.487,1.548l2.952,2.952h-1.939c-.414,0-.75.336-.75.75s.336.75.75.75h3.75c.414,0,.75-.336.75-.75V1.5c0-.414-.336-.75-.75-.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { x: "6", y: "6", width: "6", height: "6", rx: "1.75", ry: "1.75", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconFollowObjDownRightFill12.js.map